import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ImagePreviewIndicator = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  color: #6136db;
  position: relative;
  text-decoration: underline;
  line-height: 1.8;
`

export const CellPlaceholder = styled.div`
  margin: 4px;
  background-color: lightgray;
  border-radius: 2px;
`

export const Cell = styled.div`
  padding: 4px 8px;
  font-size: 12px;
`

export const compact = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`

export const medium = css`
  max-height: none;
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
  -webkit-line-clamp: 3;
`

export const tall = css`
  max-height: none;
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: -o-ellipsis-lastline;
  -webkit-line-clamp: 6;
`
